import { Travel } from './../../models/travel';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SnackBarHandlerService } from '../../commons/snack-bar-handler.service';
import { TravelsHandlerService } from '../../api-handlers/travels-handler.service';
import { AuthService } from '../../auth-n-routing/auth-service.service';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-change-km-travel',
	templateUrl: './change-km-travel.component.html',
	styleUrls: ['./change-km-travel.component.css']
})

export class ChangeKmTravelComponent implements OnInit {

	modalRef: BsModalRef;
	travel: Travel;
	@ViewChild('template', { static: false }) template;
	onClose: any;

	constructor(public authService: AuthService,
				public travelsHandlerService: TravelsHandlerService,
				public snackBarHandler: SnackBarHandlerService,
				private modalService: BsModalService, ) { }

	ngOnInit() {

	}

	showDialog(travel: Travel) {
		this.travel = travel;
		this.modalRef = this.modalService.show(this.template);
	}

	changeKm(travelForm: NgForm) {
		if (travelForm.valid && this.travel.id) {
			const updateTravel = {
				travel_id: this.travel.id,
				start_kilometers: this.travel.start_kilometers,
				end_kilometers: this.travel.end_kilometers,
				user_id: this.authService.getAuthenticatedUser().id
			};
			this.travelsHandlerService.updateTravelKilometers(updateTravel).then((trv) => {
				if (+trv.start_kilometers !== +this.travel.start_kilometers || +trv.end_kilometers !== +this.travel.end_kilometers) {
					this.travel.start_kilometers = trv.start_kilometers;
					this.travel.end_kilometers = trv.end_kilometers;
					alert('impossibile impostare il chilometraggio');
				} else {
					this.onClose();
				}
			}).catch((e) => {
				alert('salvataggio non riuscito' + e);
			});
		}

	}
}
